import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";

export function ThemeToggle() {
  const [dark, setDark] = useState(
    () => localStorage.getItem("rmb_theme") === "dark"
  );

  useEffect(() => {
    const root = document.documentElement;
    if (dark) {
      root.classList.add("dark");
      localStorage.setItem("rmb_theme", "dark");
    } else {
      root.classList.remove("dark");
      localStorage.setItem("rmb_theme", "light");
    }
  }, [dark]);

  return (
    <button
      data-testid="theme-toggle"
      onClick={() => setDark((d) => !d)}
      aria-label="Toggle dark mode"
      className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-border bg-card text-foreground transition-colors hover:bg-accent hover:text-accent-foreground"
    >
      {dark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </button>
  );
}
